module.exports = __webpack_public_path__ + "img/cooperateimg_m.3c573fcb.png";